module.exports = __webpack_public_path__ + "static/media/web.15f5d963.png";